<template>
  <v-row >
    <v-col v-if="!item.intercorrencia">
      <h2><b>Dados da Ocorrência: </b></h2><p></p>
      <p><b>Registrado Por? :</b> {{ item.equipe_remocao ?  'Plantonista' : 'Assistencial'}} - {{ item.colaborador.apelido }} - {{item.colaborador.especialidade.nome}}</p> 
      <p><b>Procedimento:</b> {{ item.tipo_ocorrencia?.nome || ''}} </p> 
      <!-- <p><b>Gerou Hospitalização:</b> {{ item.reinternacao ? 'Sim': 'Não'}} </p>  -->
     
    </v-col>
    <v-col v-if="item.intercorrencia">
      <h2><b>Dados da Intercorrência: </b></h2><p></p>
      <p><b>Registrado Por? :</b> {{ item.equipe_remocao ?  'Plantonista' : 'Assistencial'}}  - {{ item.colaborador.apelido }} - {{item.colaborador.especialidade.nome}}</p>
      <p><b>Quem Acionou:</b> {{ item.quem_acionou || ''}} </p> 
      <p><b>Tipo:</b> {{ item.tipo?.nome || ''}} </p> 
      <p><b>Causa:</b> {{ item.causa?.nome || ''}} </p> 
      <p><b>Gerou Hospitalização:</b> {{ item.reinternacao ? 'Sim': 'Não'}} </p> 
    </v-col>
    <v-col>
      <h2><b>Registro: </b></h2><p></p>
      <p> {{ item.observacao }} </p> 
    </v-col>
  </v-row>
</template>

<script>

export default {
  name: "AcionamentoExpand",
  props: {
    item: Object,
  },
}
</script>

